import { render, staticRenderFns } from "./User_Permission_List.vue?vue&type=template&id=39b03198&scoped=true&"
import script from "./User_Permission_List.vue?vue&type=script&lang=js&"
export * from "./User_Permission_List.vue?vue&type=script&lang=js&"
import style0 from "./User_Permission_List.vue?vue&type=style&index=0&id=39b03198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b03198",
  null
  
)

export default component.exports